import { Grid } from '@mantine/core';

import { BatchTypeEnum } from '@e-origin/shared';

import { CBAMReportForm } from './CBAMReportForm';
import { CustomsRegisterForm } from './CustomsRegisterForm';

export const CustomsRegister = () => {
  return (
    <>
      <Grid>
        <Grid.Col span={3}>
          <CustomsRegisterForm title="HV Customs Register" batchType={BatchTypeEnum.HIGH_VALUES} />
        </Grid.Col>
        <Grid.Col span={3} offset={1}>
          <CustomsRegisterForm title="HV Customs Register by Shippingmarks" batchType={BatchTypeEnum.HIGH_VALUES} groupByShippingMarks={true} />
        </Grid.Col>
        <Grid.Col span={3} offset={1}>
          <CustomsRegisterForm title="Export Customs Register" batchType={BatchTypeEnum.HIGH_VALUES_EXPORT} />
        </Grid.Col>
      </Grid>
      <Grid mt="xl">
        <Grid.Col span={3}>
          <CustomsRegisterForm title="LV Customs Register" batchType={BatchTypeEnum.LOW_VALUES} />
        </Grid.Col>
        <Grid.Col span={3} offset={1}>
          <CBAMReportForm />
        </Grid.Col>
      </Grid>
    </>
  );
};
